export const NAMED_COLORS = [
  { name: "Default", value: "#E5E7EB" },
  { name: "Gray", value: "#D1D5DB" },
  { name: "Brown", value: "#D4A574" },
  { name: "Orange", value: "#FDBA74" },
  { name: "Yellow", value: "#FCD34D" },
  { name: "Green", value: "#86EFAC" },
  { name: "Blue", value: "#93C5FD" },
  { name: "Purple", value: "#C4B5FD" },
  { name: "Pink", value: "#F9A8D4" },
  { name: "Red", value: "#FCA5A5" },
];

export function randomOptionColor(): string {
  return NAMED_COLORS[Math.floor(Math.random() * NAMED_COLORS.length)].value;
}
